module.exports = __webpack_public_path__ + "img/GNB.271842fc.svg";